import { useEffect } from 'react';

import { isBrowser } from '@lucid/utils';

const useUrlPathUpdate = (path: string) => {
  useEffect(() => {
    if (isBrowser()) {
      const currentUrlParams = window.location.search; // Get the current URL parameters
      window.history.replaceState({}, '', `${path ? path : '/'}${currentUrlParams}`);
    }
  }, [path]);
};

export default useUrlPathUpdate;
